/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* TollData
*/
export class TollData {
    'id'?: number;
    'documentType': string;
    'documentNumber': string;
    'addedBy': TollDataAddedByEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "documentType",
            "baseName": "documentType",
            "type": "string",
            "format": ""
        },
        {
            "name": "documentNumber",
            "baseName": "documentNumber",
            "type": "string",
            "format": ""
        },
        {
            "name": "addedBy",
            "baseName": "addedBy",
            "type": "TollDataAddedByEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return TollData.attributeTypeMap;
    }

    public constructor() {
    }
}


export type TollDataAddedByEnum = "trucker" | "terminal" | "forwarder_operator" ;

